<panel width="1000">
  <h1>{{ 'invoice-objection-search.header' | translate }}</h1>

  <section>
    <reason-select [label]="'invoice-objection-search.reason-select' | translate" [(reasonId)]="searchRequest.reasonFilter" />
    <custom-input [label]="'invoice-objection-search.only-open' | translate" [inputType]="inputTypeEnum.Switch" [(value)]="searchRequest.onlyOpenInvoices" />
  </section>
  <section>
    <button #searchButton (click)="search()" [label]="'invoice-objection-search.search' | translate" [ignoreValidation]="true"></button>
  </section>

  @if (searching) {
    <skeletons [defaultSkeletons]="5" />
  }
  @if (!searching) {
    <list-view #objectionList scrollable>
      <header defaultSort="ascending">{{ 'general.column.company-name' | translate }}</header>
      <header>{{ 'invoice-objection-search.reason' | translate }}</header>
      <header>{{ 'invoice-objection-search.comment' | translate }}</header>
      <header>{{ 'invoice-objection-search.user' | translate }}</header>
      <header align-right>{{ 'invoice-objection-search.amount' | translate }}</header>
      <header align-right>{{ 'invoice-objection-search.created-date' | translate }}</header>
      <header align-right defaultSort="ascending">{{ 'invoice-objection-search.registered-date' | translate }}</header>
      <row data-id="{{ objection.id }}" *listData="let objection from invoiceObjections" (action)="selectedInvoiceObjection = objection" [select]="selectedInvoiceObjection?.id == objection.id">
        <column>{{ objection.company?.name }}</column>
        <column>{{ objectionReasons.get(objection.reasonId)?.name ?? ('reason.unknown' | translate)}}</column>
        <column>{{ objection.comment }}</column>
        <column>{{ objection.user | user: "name" }}</column>
        <column [sortValue]="objection.ledgerEntry?.amount" align-right>{{ objection.ledgerEntry?.amount | currency }}</column>
        <column [sortValue]="objection.startDate" align-right>{{ objection.created | customDate: 'shortDate' }}</column>
        <column [sortValue]="objection.endDate" align-right>{{ objection.registeredDate | customDate: 'shortDate' }}</column>
      </row>
    </list-view>
  }
</panel>

@if (selectedInvoiceObjection) {
  <ledger-entry-details [objection]="selectedInvoiceObjection" [ledgerEntry]="selectedInvoiceObjection.ledgerEntry" [companyId]="selectedInvoiceObjection.companyId" />
}

